import { createNorvixMuiTheme } from '@norvix/ui';

export const theme = createNorvixMuiTheme();
